var _circle, _g, _path, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKosovo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "#0052b4",
    r: 256
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f0f0f0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m112.449 155.827 5.526 17.008h17.88l-14.465 10.509 5.525 17.005-14.466-10.509-14.467 10.509 5.527-17.005-14.466-10.509h17.879z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m168.101 139.132 5.526 17.007h17.88l-14.465 10.509 5.525 17.005-14.466-10.509-14.466 10.509 5.526-17.005-14.465-10.509h17.88z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m223.753 122.436 5.526 17.007h17.88l-14.465 10.51 5.525 17.005-14.466-10.51-14.466 10.51 5.526-17.005-14.465-10.51h17.88z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m399.551 155.827-5.526 17.008h-17.88l14.466 10.509-5.526 17.005 14.466-10.509 14.467 10.509-5.527-17.005 14.466-10.509h-17.88z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m343.899 139.132-5.526 17.007h-17.88l14.466 10.509-5.526 17.005 14.466-10.509 14.466 10.509-5.526-17.005 14.465-10.509h-17.88z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m288.247 122.436-5.526 17.007h-17.88l14.465 10.51-5.525 17.005 14.466-10.51 14.466 10.51-5.526-17.005 14.465-10.51h-17.88z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m300.522 267.13-44.522-55.652-22.261 11.13v22.261l-33.391 22.261h-22.261v28.759c32.628 13.212 55.652 45.181 55.652 82.546h22.261v-22.261l22.261-22.261 22.261 22.261 22.261-22.261v-22.261l22.261-33.391z",
    fill: "#ffda44"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKosovo);
export default __webpack_public_path__ + "static/media/kosovo.e7fbef1bb3485e4d72bf5457b1b0557c.svg";
export { ForwardRef as ReactComponent };